import Collection from "../../data-structures/collection";
import Link from "./link";


export default class Links extends Collection<Link> {

    constructor(models: Link[]) {
        super(models);
    }


    static initFromJSON(data:JSONArray): Links {

        const collection = new Links([])

        _.map(data, (item)=> {
            collection.add(new Link(item))
        })

        return collection
    }

}
